module.exports = __webpack_public_path__ + "static/media/arrow-to-bottom.af86483c.svg";